import { useContext } from 'react';
import { Context } from '../components/Provider';

const useSidebarContext = () => useContext(Context);

export default useSidebarContext;
